import React from 'react'
import { Modal } from 'antd'
import PropTypes from 'prop-types'
import { youtubeVideoDetails } from '@edulastic/constants'
import TokenizedYouTubePlayer from './TokenizedYouTubePlayer'

const IframeVideoModal = ({ visible, closeModal, questionTitle = '' }) => {
  const videoDetails = youtubeVideoDetails[questionTitle]

  // looads component only when video details is available
  if (!videoDetails) return null

  const { title = '', videoId = '', uiConfig } = videoDetails

  const { width, height } = uiConfig

  return (
    <Modal
      visible={visible}
      onCancel={closeModal}
      title={title}
      footer={null}
      destroyOnClose
      width="768px" // not responsive
    >
      {/* Tokenized v2 player so the help video plays on domains where YouTube
          enforces Embedder Identity (raw iframes fail with error 152). */}
      <TokenizedYouTubePlayer
        url={`https://www.youtube.com/embed/${videoId}?utm_source=Application&utm_medium=Clicks&utm_campaign=Dashboard_Quick_Start_Overview`}
        width={width}
        height={height}
        playerVars={{ autoplay: 1 }}
      />
    </Modal>
  )
}

IframeVideoModal.propTypes = {
  visible: PropTypes.bool,
  closeModal: PropTypes.func.isRequired,
  questionTitle: PropTypes.string,
}

IframeVideoModal.defaultProps = {
  visible: false,
  questionTitle: '',
}

export default IframeVideoModal
